import LabeledInput from "../components/LabeledInput";
import PasswordInput from "../components/PasswordInput";
import ButtonSave from "../components/ButtonSave";
import { FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form";
import ErrorWrap from "../components/ErrorWrap";

type PassField = "password" | "newPassword" | "confirmPassword" | null;

interface Props {
  openField: PassField;
  toggle: (f: Exclude<PassField, null>) => void;
  register: UseFormRegister<any>;
  errors: FieldErrors;
  hasUnsavedChanges: boolean;
  watch: UseFormWatch<any>;
}

export default function AccountTab({
  openField,
  toggle,
  register,
  errors,
  hasUnsavedChanges,
}: Props) {
  const isOpen = (f: Exclude<PassField, null>) => openField === f;
  return (
    <>
      <div className="cabinet_profileeditmodal-right-content">
        <div className="cabinet_profileeditmodal-right-content-text">
          <div className="cabinet_profileeditmodal-right-content-text-title">
            Аккаунт
          </div>
          <div className="cabinet_profileeditmodal-right-content-text-description">
            Данные для входа
          </div>
        </div>
        <LabeledInput
          label="Логин"
          inputName="username"
          register={register}
          errors={errors}
        />
        <ErrorWrap>
          <PasswordInput
            placeholder="Пароль"
            isVisible={isOpen("password")}
            toggle={() => toggle("password")}
            inputName="password"
            register={register}
            errors={errors}
          />
        </ErrorWrap>
        <ErrorWrap>
          <PasswordInput
            placeholder="Новый пароль"
            isVisible={isOpen("newPassword")}
            toggle={() => toggle("newPassword")}
            inputName="newPassword"
            register={register}
            errors={errors}
          />
        </ErrorWrap>
        <ErrorWrap>
          <PasswordInput
            placeholder="Подтвердите пароль"
            isVisible={isOpen("confirmPassword")}
            toggle={() => toggle("confirmPassword")}
            inputName="confirmPassword"
            register={register}
            errors={errors}
          />
        </ErrorWrap>
      </div>
      <ButtonSave hasUnsavedChanges={hasUnsavedChanges} />
    </>
  );
}
